import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useQuery, useQueryClient } from "react-query";
import {
  buyPromotionTicket,
  buyTicket,
  checkPromotionUnused,
} from "../../services/game.service";

interface PopUpConfirmProps {
  open: boolean;
  data: number[]; // selectTicketNumbers
  roomId: string;
  onClose: () => void;
  onStartOpen: (data: any) => void;
}

export default function PopUpConfirm({
  open,
  data,
  roomId,
  onClose,
  onStartOpen,
}: PopUpConfirmProps) {
  const queryClient = useQueryClient();
  const [loading, setLoading] = useState(false);

  const { data: promotionActive, refetch } = useQuery(
    ["check-promotion-unused"],
    async () => {
      return await checkPromotionUnused({});
    }
  );

  const onSubmit = async () => {
    setLoading(true);
    try {
      // buyTicket() will read token from sessionStorage if not passed explicitly
      if (promotionActive?.isPromotionActive) {
        const response = await buyPromotionTicket({
          selectTicketNumbers: data,
          roomId,
        });
        console.log("response:::", response);
        refetch();
        // successAdd("ຊື້ສຳເລັດ"); // ถ้ามี sweetalert
        onStartOpen(response);
      } else {
        const response = await buyTicket({
          selectTicketNumbers: data,
          roomId,
        });
        console.log("response:::", response);
        // successAdd("ຊື້ສຳເລັດ"); // ถ้ามี sweetalert
        onStartOpen(response);
      }
    } catch (error) {
      // errorAdd("ຊື້ບໍ່ສຳເລັດ"); // ถ้ามี sweetalert
      onClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      show={open}
      onHide={onClose}
      keyboard={false}
      style={{ border: "none" }}
      centered
      size="sm"
    >
      <Modal.Header
        style={{
          border: "none",
          textAlign: "center",
          justifyContent: "center",
        }}
      >
        <Modal.Title
          style={{
            border: "none",
            textAlign: "center",
            justifyContent: "center",
          }}
        >
          ຍືນຍັນການຊື້
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex flex-column gap-3 items-center">
          <div>ເລກທີເລືອກ</div>
          <div style={{ fontWeight: 700, fontSize: "1.2rem" }}>
            {data?.map((e: any) => e).join(", ")}
          </div>
          <div>
            ເປັນຈຳນວນ:{" "}
            <span style={{ fontWeight: 700, fontSize: "1.2rem" }}>
              {!!promotionActive?.isPromotionActive ? "" : `${data?.length} 💎`}
            </span>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer
        style={{ border: "none", justifyContent: "center", gap: 10 }}
      >
        <Button
          variant="secondary"
          onClick={onClose}
          disabled={loading}
          className="flex-1 h-[45px]"
        >
          ຍົກເລີກ
        </Button>
        <Button
          variant="primary"
          onClick={onSubmit}
          disabled={loading}
          className="flex-1 h-[45px]"
        >
          {loading ? "ກຳລັງຊື້..." : "ຢືນຍັນ"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
